<template>
  <component
    :is="tag"
    :class="computedClasses"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import type { HeadingComponent } from './types'

const props = withDefaults(defineProps<{
  tag?: HeadingComponent
  level: 1 | 2 | 3
}>(), {
  tag: 'h1',
})

const computedClasses = computed(() => {
  return [
    'font-bold tracking-tight',
    {
      'text-4xl md:text-5xl lg:text-6xl/16': props.level === 1,
      'text-3xl md:text-4xl lg:text-5xl/14': props.level === 2,
      'text-2xl md:text-3xl lg:text-4xl': props.level === 3,
    },
  ]
})
</script>
